import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Home, Package, Mail } from "lucide-react";
import { IMAGES } from "@/lib/site";

export default function NotFound() {
  useEffect(() => {
    document.title = "Page not found — Stenzia Displays";
  }, []);

  return (
    <div data-testid="not-found-page" className="relative min-h-[80vh] flex items-center justify-center bg-charcoal text-white overflow-hidden">
      <img
        src={IMAGES.heroAlt}
        alt=""
        aria-hidden="true"
        draggable="false"
        className="absolute inset-0 w-full h-full object-cover opacity-20"
      />
      <div className="absolute inset-0 bg-gradient-to-tr from-charcoal/95 via-charcoal/85 to-charcoal/95" />

      <div className="relative max-w-3xl mx-auto px-6 md:px-12 py-24 text-center">
        <div className="overline text-stenzia-gold">404 · Page Not Found</div>
        <h1 className="mt-6 font-display font-light text-5xl md:text-7xl lg:text-8xl tracking-tighter leading-[0.95]">
          This page<br />doesn&apos;t exist.
        </h1>
        <p className="mt-7 text-white/65 max-w-xl mx-auto leading-relaxed text-sm md:text-base">
          The page you were looking for has moved or was never built. Pick a destination below — our engineering team is one click away.
        </p>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
          <Link to="/" data-testid="404-home" className="group inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white text-charcoal text-sm font-medium hover:bg-stenzia-green hover:text-white transition-colors">
            <Home size={15} /> Back Home <ArrowUpRight size={14} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
          <Link to="/products" data-testid="404-products" className="group inline-flex items-center gap-2 px-6 py-3 rounded-full border border-white/20 text-white/90 text-sm hover:bg-white/10 hover:border-white/40 transition-colors">
            <Package size={15} /> Explore Products
          </Link>
          <Link to="/contact" data-testid="404-contact" className="group inline-flex items-center gap-2 px-6 py-3 rounded-full border border-white/20 text-white/90 text-sm hover:bg-white/10 hover:border-white/40 transition-colors">
            <Mail size={15} /> Contact Us
          </Link>
        </div>
      </div>
    </div>
  );
}
